import * as React from 'react';
import { Outlet } from 'react-router-dom';

import SharedLayout from './SharedLayout';

export default function HeaderBase() {
	return (
		<SharedLayout
			headerProps={{
				title: "Online Battery Validation Manager",
				drawerIcon: false,
				onDrawerToggle: () => {}
			}}
		>
			<Outlet />
		</SharedLayout>
	);
}
